import { render, staticRenderFns } from "./PortalInput.vue?vue&type=template&id=84d6cc8a&"
import script from "./PortalInput.vue?vue&type=script&lang=ts&"
export * from "./PortalInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports